import "./octocat.scss";

const Github_Icon = ({ isIntersecting }) => {
  return (
    <a href="https://github.com/RodriOrozco" target="_blank" rel="noreferrer">
      {isIntersecting ? (
        <video autoPlay loop muted playsInline className="video-tag-github">
          <source
            src={require("../../assets/octocat-github.webm")}
            type="video/webm"
          />
          <source
            src={require("../../assets/octocat-github.mp4")}
            type="video/mp4"
          />
        </video>
      ) : (
        <img
          src={require("../../assets/octocat-github.gif")}
          alt=""
          className="video-tag-github"
        />
      )}
    </a>
  );
};

export default Github_Icon;
